import { InventoryEventTabs } from 'src/components/Listings/InventoryEventPage/InventoryEventTabs';
import { useContextSelector } from 'use-context-selector';

import { POSSignalRHub } from '../SignalRConnection';
import {
  EventHubContextWithSelector,
  EventSessionRole,
  IEventHubContext,
} from './EventHubContext';

const useEventHubContextValueSelector = <T>(
  selector: (context: IEventHubContext) => T
): T => {
  const contextValue = useContextSelector(
    EventHubContextWithSelector,
    selector
  );
  return contextValue;
};

export const useEventHubContextEnabledSelector = (): boolean => {
  return useEventHubContextValueSelector((context) => context.enabled);
};

export const useEventHubContextHubConnectionSelector = ():
  | POSSignalRHub
  | undefined => {
  return useEventHubContextValueSelector((context) => context.hubConnection);
};

export const useEventHubContextSessionRoleSelector = ():
  | EventSessionRole
  | undefined => {
  return useEventHubContextValueSelector((context) => context.sessionRole);
};

export const useEventHubContextIsOnSidePanelSelector = (): boolean => {
  return useEventHubContextValueSelector((context) => context.isOnSidePanel);
};

export const useEventHubContextIsOnCompanionEventSelector = (): boolean => {
  return useEventHubContextValueSelector(
    (context) => context.isOnCompanionEvent
  );
};

export const useEventHubContextOnStartSessionSelector = (): (() => void) => {
  return useEventHubContextValueSelector((context) => context.onStartSession);
};

export const useEventHubContextOnCancelSessionSelector = (): (() => void) => {
  return useEventHubContextValueSelector((context) => context.onCancelSession);
};

export const useEventHubContextOnSelectEventSelector = (): ((
  eventVirtualId?: string,
  forceStart?: boolean
) => void) => {
  return useEventHubContextValueSelector((context) => context.onSelectEvent);
};

export const useEventHubContextOnSelectListingsSelector = (): ((
  listingIds: number[]
) => void) => {
  return useEventHubContextValueSelector((context) => context.onSelectListings);
};

export const useEventHubContextOnUpdateListingSelector = (): ((
  listingId: number
) => void) => {
  return useEventHubContextValueSelector((context) => context.onUpdateListing);
};

export const useEventHubContextOnUpdateInventoryTabSelector = (): ((
  tab: InventoryEventTabs
) => void) => {
  return useEventHubContextValueSelector(
    (context) => context.onUpdateInventoryTab
  );
};

export const useEventHubContextSelectedEventVirtualIdSelector = ():
  | string
  | undefined => {
  return useEventHubContextValueSelector(
    (context) => context.selectedEventVirtualId
  );
};

export const useEventHubContextSelectedListingIdsSelector = ():
  | number[]
  | undefined => {
  return useEventHubContextValueSelector(
    (context) => context.selectedListingIds
  );
};

export const useEventHubContextSelectedVenueMapSectionsSelector =
  (): number[] => {
    return useEventHubContextValueSelector(
      (context) => context.selectedVenueMapSections
    );
  };

export const useEventHubContextInventoryTabSelector = ():
  | InventoryEventTabs
  | undefined => {
  return useEventHubContextValueSelector((context) => context.inventoryTab);
};

export const useEventHubContextonSectionsSelectedSelector = (): ((
  sectionIds: number[]
) => void) => {
  return useEventHubContextValueSelector(
    (context) => context.onSectionsSelected
  );
};
